import { render, staticRenderFns } from "./SalesAchivied.vue?vue&type=template&id=1eb643c2&"
import script from "./SalesAchivied.vue?vue&type=script&lang=js&"
export * from "./SalesAchivied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports